module.exports = __webpack_public_path__ + "img/support.96c8cac2.svg";